/*
 * This script provides functionality for a slider which is to be navigated with some list of content. Where slider is
 * .js-showcase-showbox and the list of items that serve as navigation is .js-showcase-navigables.
 * Slider is managed by owl.carousel and the nav items functionality is built upon owl's api.
 *
 *
 * The navigation list as well as the owl slider requires to be hooked directly on list's container:
 *
 * E.g.:
 *   .js-showcase-navigables
 *       .item
 *       .item
 *       .item
 *
 * @TODO check on accessibility implementation once OWL's accessibility is implemented
 *
 * */
(function () {
    var showcaseSlideshow = {
        selectors: {
            navigation: '.js-showcase-navigables',
            showbox: '.js-showcase-showbox',
            instance: '.js-showcase-slideshow',
            currentItemClass: 'js-showcase-current',
        },
        defaultOptions: {},
        instances: [],
        applyOptions: function (options, obj) {
            /* this allows to apply different options for each slider on the page */
            return options;
        },

        init: function (options) {
            /* slider behaviour can be customised here for all the sliders on the website */

            /*
             * Custom options structue:
             * {
             *   navigationEvent: 'mouseover' || 'click' || ... ,
             *   sliderOptions: {
             *      [... Owl Slider Options]
             *   }
             * }
             *
             * */

            showcaseSlideshow.defaultOptions = typeof options === 'object' ? options : {};
            const instances = $(showcaseSlideshow.selectors.instance);

            if (typeof $.fn.owlCarousel === 'function' && instances.length) {
                instances.each(function (i, o) {
                    showcaseSlideshow.initInstance(o, showcaseSlideshow.defaultOptions);
                });
            }
        },
        initInstance(element, options) {
            let instance = $(element),
                singularOptions = options;

            if (typeof options === 'undefined') {
                options = showcaseSlideshow.defaultOptions;
            }

            if (typeof showcaseSlideshow.applyOptions === 'function') {
                /* Different options can be applied for each slider by rewriting the callback */
                // cloning options from the source for each slider instance to prevent any unintentional modifications
                singularOptions = showcaseSlideshow.applyOptions($.extend(true, {}, options), instance);
            }

            showcaseSlideshow.initNavigation(
                instance,
                singularOptions
            ); /* The order of initiation is important. Navigation has to be created before slider init. */

            let sliderOptions = typeof singularOptions.sliderOptions === 'object' ? singularOptions.sliderOptions : {}; // extracting slider options from common options array
            showcaseSlideshow.initShowbox(instance, sliderOptions);

            showcaseSlideshow.instances.push(instance);
        },
        initNavigation: function (instance, options) {
            var event = typeof options !== 'undefined' && !!options.navigationEvent ? options.navigationEvent : 'click'; // default event is click
            instance.showboxNavigation = instance.find(showcaseSlideshow.selectors.navigation);
            instance.showboxNavigation.children().on(event + '.showcaseSlideshow', function (e) {
                /* @TODO allow event type customisation */
                var item = instance.showboxNavigation.children().index(this);
                instance.showbox.trigger('to.owl.carousel', [item]); // what is the default speed?
            });

            instance.showboxNavigation.on(event, 'a', function (e) {
                // that's mostly for those content elements that come to us as html and we cant set it up without anchors. Like the authors.
                e.preventDefault();
            });
        },
        initShowbox: function (instance, customOptions) {
            var defaultOptions = {
                    navigation: true, // Show next and prev buttons
                    items: 1,
                    singleItem: true,
                    loop: true, // When loop is on owl carousel gives incorrect indexes
                    margin: 0,
                    transitionStyle: 'fade',
                    dots: false,
                    // autoWidth: true,
                    onChanged: function (e) {
                        if (e.property.name === 'position') showcaseSlideshow.onChangeNavCurrentItem(e, instance); // pass the data of
                    },
                    onInitialized: function () {
                        showcaseSlideshow.setNavCurrentItem(instance);
                        showcaseSlideshow.initNavigationArrows(instance);
                    },
                },
                options = $.extend({}, defaultOptions, customOptions);
            instance.showbox = instance
                .find(showcaseSlideshow.selectors.showbox)
                .addClass('owl-carousel')
                .owlCarousel(options);
        },

        setNavCurrentItem: function (instance) {
            /* @TODO check if an initialization with a preset position is possible, implement support if this is the case */
            if (typeof instance.showboxNavigation !== 'undefined')
                instance.showboxNavigation.children().eq(0).addClass(showcaseSlideshow.selectors.currentItemClass);
            else {
                console.log('No navigation was passed.');
            }
        },

        onChangeNavCurrentItem: function (e, instance) {
            var items = instance.find(showcaseSlideshow.selectors.navigation).children(),
                settings = instance.showbox.data('owl.carousel'), // accessing setting of the owl carousel
                order = 0; // default active item

            if (settings.options.loop === true) {
                const normalOrder = e.item.index - e.relatedTarget.clones().length / 2; // fix for the enabled loop in the owl settings
                order = normalOrder === e.item.count ? 0 : normalOrder; // if index of items is one too many it means we are back on the start
            } else {
                order = e.property.value;
            }

            const currentItem = items
                .removeClass(showcaseSlideshow.selectors.currentItemClass)
                .eq(order)
                .addClass(showcaseSlideshow.selectors.currentItemClass);

            /* @TODO implement scroll control with modules options */
            showcaseSlideshow.maybeScrollTo(currentItem);

            /* As can be seen above items should follow immediately without any subcontainers.
               That is to allow no specific selectors but just children usage for a wider application of the script
            */
        },

        maybeScrollTo: function (item) {
            var position = item.position(),
                parent = item.parent(),
                to = false;

            if (Math.ceil(position.top) >= parent.height() || position.top + item.outerHeight() > parent.height()) {
                /* the item is down below the fold */
                to = parent.scrollTop() + position.top + item.outerHeight() - parent.height();
            } else if (position.top < 0) {
                /* the item is up above the fold */
                to = parent.scrollTop() + position.top;
            }

            if (to !== false) {
                parent.animate({
                    scrollTop: to,
                });
            }
            /*
                check if the item's in visible range if not manipulate scroll so the item will appear at the closest edge to its relative position
            */
        },

        initNavigationArrows: function (instance, prevSelector, nextSelector) {
            /* custom arrows can be passed and customised */
            var prevArrow =
                    typeof prevSelector !== 'undefined'
                        ? instance.find(prevSelector)
                        : instance.find('.js-showcase-prev'),
                nextArrow =
                    typeof nextSelector !== 'undefined'
                        ? instance.find(nextSelector)
                        : instance.find('.js-showcase-next');

            prevArrow.on('click.showcaseSlideshow', function (e) {
                e.preventDefault();
                instance.showbox.trigger('prev.owl.carousel');
            });

            nextArrow.on('click.showcaseSlideshow', function (e) {
                e.preventDefault();
                instance.showbox.trigger('next.owl.carousel');
            });
        },
    };

    UX.showcaseSlideshow = showcaseSlideshow;
})();
